import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ParticipationTrendComponent } from './participation-trend.component';
import {HighchartsChartModule} from "highcharts-angular";
import {AlertBannerModule} from "../../lib/alert-banner";



@NgModule({
  declarations: [ParticipationTrendComponent],
  imports: [
    CommonModule,
    HighchartsChartModule,
    AlertBannerModule.forRoot(),
  ],
  exports: [ParticipationTrendComponent]
})
export class ParticipationTrendModule { }
